import { FILE_SELECTIONS_TAG_NAME } from './constants';
import type { FileSelection } from '~/types/chat';

export function fileSelectionsToXML(selections?: FileSelection[]) {
  if (!selections || !selections.length) {
    return undefined;
  }

  return [
    `<${FILE_SELECTIONS_TAG_NAME}>`,
    ...selections.map(({ text, filePath, range }) => {
      return `<selection path=${JSON.stringify(filePath)} range="${range.from}:${range.to}">${text}</selection>`;
    }),
    `</${FILE_SELECTIONS_TAG_NAME}>`,
  ].join('\n');
}
